'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEntityActive;

var _getEntityAtCursor = require('./getEntityAtCursor');

var _getEntityAtCursor2 = _interopRequireDefault(_getEntityAtCursor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isEntityActive(editorState, name) {
  var entityAtCursor = (0, _getEntityAtCursor2.default)(editorState);
  var entityKey = entityAtCursor && entityAtCursor.entityKey;
  var contentState = editorState.getCurrentContent();
  var entity = entityKey && contentState.getEntity(entityKey);

  return entity != null && entity.type === name;
}
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInV0aWxzL2lzRW50aXR5QWN0aXZlLmpzIl0sIm5hbWVzIjpbImlzRW50aXR5QWN0aXZlIiwiZWRpdG9yU3RhdGUiLCJuYW1lIiwiZW50aXR5QXRDdXJzb3IiLCJlbnRpdHlLZXkiLCJjb250ZW50U3RhdGUiLCJnZXRDdXJyZW50Q29udGVudCIsImVudGl0eSIsImdldEVudGl0eSIsInR5cGUiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUV3QkEsYzs7QUFGeEI7Ozs7OztBQUVlLFNBQVNBLGNBQVQsQ0FBd0JDLFdBQXhCLEVBQXFDQyxJQUFyQyxFQUEyQztBQUN4RCxNQUFJQyxpQkFBaUIsaUNBQWtCRixXQUFsQixDQUFyQjtBQUNBLE1BQUlHLFlBQVlELGtCQUFrQkEsZUFBZUMsU0FBakQ7QUFDQSxNQUFJQyxlQUFlSixZQUFZSyxpQkFBWixFQUFuQjtBQUNBLE1BQUlDLFNBQVNILGFBQWFDLGFBQWFHLFNBQWIsQ0FBdUJKLFNBQXZCLENBQTFCOztBQUVBLFNBQVFHLFVBQVUsSUFBVixJQUFrQkEsT0FBT0UsSUFBUCxLQUFnQlAsSUFBMUM7QUFDRCIsImZpbGUiOiJ1dGlscy9pc0VudGl0eUFjdGl2ZS5qcyIsInNvdXJjZVJvb3QiOiJFOlxccHJvamVjdHNcXHJlZHV4LWRyYWZ0XFxzcmMifQ==



//////////////////
// WEBPACK FOOTER
// ../lib/utils/isEntityActive.js
// module id = 591
// module chunks = 0